import React, { useEffect, useState, useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'
import { PATHS } from '../../../../../../../Config/Routing/paths'
import { withStyles, IconButton, Menu, MenuItem } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import EnhancedTable from '../../../../../../../Components/EnhancedTable'
import { authorization } from '../../../../../../../Module/Auth/Auth'
import ControlButtonsSection from '../ControlButtonsSection'
import LoadingIndicator from '../../../../../../../Components/LoadingIndicator/LoadingIndicator'
import { headersEnrollments, optionsStatuses } from '../../options'
import Select from '../Select'
import { styles } from './styles'
import useGraphQLFetch from '../../../../../../../Utils/Hooks/useGraphQLFetch'
import { findEmailStat } from '../../gql'
import { useDuplicateSequence } from '../../hooks/useDuplicateSequence'

const calculateStates = state => {
  switch (state) {
    case 'clicked':
      return ['CLICKED']
    case 'opened':
      return ['OPENED']
    case 'notOpened':
      return ['SENT', 'RESENT', 'SCHEDULED']
    case 'notDelivered':
      return ['FAILED', 'CANCELLED']
    case 'all':
    default:
      return []
  }
}

const stateToStatus = {
  'CLICKED': 'Clicked',
  'OPENED': 'Opened',
  'SENT': 'Not opened',
  'RESENT': 'Not opened',
  'FAILED': 'Not delivered',
  'CANCELLED': 'Not delivered',
  'SCHEDULED': 'Scheduled',
}

const EnrollmentsView = ({
  cityId,
  cityName,
  countryName,
  classes,
  pipelineStage,
  url,
}) => {
  const { sequenceId } = useParams()
  const history = useHistory()
  const { onDuplicateSequence } = useDuplicateSequence({
    cityId,
    cityName,
    countryName,
  })
  const user = useMemo(() => authorization.getUser(), [])
  const [state, setState] = useState('all')
  const [page, setPage] = useState(0)
  const [rows, setRows] = useState([])
  const [allRows, setAllRows] = useState([])
  const [order, setOrder] = useState('DESC')
  const [orderBy, setOrderBy] = useState('SENT')
  const [resultPerPage, setResultPerPage] = useState(10)
  const [selectedUser, setSelectedUser] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const open = Boolean(anchorEl)
  const ITEM_HEIGHT = 48
  const totalCount = allRows.length

  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: findEmailStat,
    defaultFetchArgs: {
      sequenceId,
      orderBy,
      order,
      state: calculateStates(state),
    },
  })

  const onChangePage = page => {
    setPage(page)
  }

  const onChangeRowsPerPage = value => {
    setResultPerPage(value)
    setPage(0)
  }

  const onClickEdit = () => {
    history.push(
      url +
        PATHS.cities.ambassadorsEmails +
        '/' +
        sequenceId +
        PATHS.cities.edit,
    )
  }

  const handleActionsClick = (event, userId) => {
    setAnchorEl(event.currentTarget)
    setSelectedUser(userId)
  }

  const handleActionsClose = () => {
    setAnchorEl(null)
    setSelectedUser(null)
  }

  const popupOptions = [
    {
      id: 1,
      label: 'User profile',
      func: () => {
        handleActionsClose()
        const baProfileUrl = PATHS.cities.ambassadorProfile
          .replace(':cityId', cityId)
          .replace(':ambassadorId', selectedUser)
        history.push(baProfileUrl)
      },
    },
  ]

  const createRowsEnrollments = data =>
    data.map(row => ({
      params: {
        highLight: null,
        id: row.messageId,
        disableClick: ['actions'],
      },
      row: {
        sent: moment(Number(row.sentAt)).format('DD/MM/YYYY HH:mm'),
        name: `${row.firstName} ${row.lastName}`,
        state: stateToStatus[row.state],
        emailName: row.emailName,
        pipelineStage:
          pipelineStage.charAt(0).toUpperCase() + pipelineStage.slice(1),
        open: row.openCount,
        click: row.clicksCount,
        actions: (
          <div>
            <IconButton
              onClick={event => handleActionsClick(event, row.userId)}
            >
              <MoreVert fontSize="small" />
            </IconButton>
          </div>
        ),
      },
    }))

  const handleRequestSort = (event, property) => {
    property = property.toUpperCase()
    if (orderBy === property) {
      setOrder(order === 'DESC' ? 'ASC' : 'DESC')
    } else {
      setOrderBy(property)
      setOrder('DESC')
    }
  }

  useEffect(() => {
    if (isLoaded && data && data.hasOwnProperty('findEmailStat')) {
      setAllRows(createRowsEnrollments(data.findEmailStat))
      setIsLoading(false)
    }
  }, [isLoaded])

  useEffect(() => {
    setRows(allRows.slice(page * resultPerPage, (page + 1) * resultPerPage))
  }, [allRows, page, resultPerPage])

  useEffect(() => {
    if (!isLoading) {
      setIsLoading(true)
      refetch({
        sequenceId,
        orderBy,
        order,
        state: calculateStates(state),
      })
    }
  }, [sequenceId, pipelineStage, order, orderBy, state])

  return isLoading ? (
    <LoadingIndicator style={{ height: '100vh' }} />
  ) : (
    <div className={classes.tableWrapper}>
      <ControlButtonsSection
        userRole={user.role}
        onBack={() => history.push(url + PATHS.cities.ambassadorsEmails)}
        onClickEdit={onClickEdit}
        onDuplicateSequence={onDuplicateSequence}
        isEnrollment
      />
      <h3>Enrollments</h3>
      <div className={classes.selectWrap}>
        <Select
          label="Status:"
          value={state}
          options={optionsStatuses}
          onChange={setState}
        />
      </div>
      <EnhancedTable
        headers={headersEnrollments}
        rows={rows}
        resultPerPage={resultPerPage}
        onChangePage={onChangePage}
        totalCount={totalCount}
        onChangeRowsPerPage={onChangeRowsPerPage}
        handleRequestSort={handleRequestSort}
        order={order}
        orderBy={orderBy}
        page={page}
        rowsPerPageOptions={[10, 25, 50, 100, 200]}
      />
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleActionsClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
          },
        }}
      >
        {popupOptions.map(item => (
          <MenuItem onClick={() => item.func()}>
            <div className={classes.popupItem}>{item.label}</div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default withStyles(styles)(EnrollmentsView)
